import { Service } from "../components/FormComponents/CustomerForm.types";
import { trackEvent } from "../services/analytics.service";

export function pushGTMEvent(
  event: string,
  service?: Service,
  extraFields?: Record<string, any>,
) {
  if (!service) return;
  trackEvent(event, {
    service_label: service.label,
    service_type: service.type,
    ...extraFields,
  });
}
